import React from 'react'
import { FaTrash } from 'react-icons/fa6'

const DeleteModal = ({setShowModal, handleDelete, title}) => {
  return (
    <>
    <div className="modal position-absolut top-0 start-0 d-flex justify-content-center align-items-center">
        <div className="modal_box bg-white d-flex flex-column justify-content-center align-items-center">
            <div>
                <FaTrash className='text-danger fs-2'/>
            </div>
            <h5 className='mt-3'>Delete {title}</h5>
            <p>Are you sure you want to delete this {title}</p>
            <div className='mt-3'>
                <button className='btn btn-primary' onClick={handleDelete}>Delete</button>
                <button className='btn ms-4 border-0 cancel' onClick={() => setShowModal(false)}>Cancel</button>
            </div>
        </div>
    </div>
    </>
  )
}

export default DeleteModal